<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_ActiveDirectory_Field_TenantID')"
        prop="params.ad_tenant_id"
      >
        <el-input
          v-model="model.params.ad_tenant_id"
          :placeholder="$t('Integrations_ActiveDirectory_Field_TenantID')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_ActiveDirectory_Field_ClientID')"
        prop="params.ad_client_id"
      >
        <el-input
          v-model="model.params.ad_client_id"
          :placeholder="$t('Integrations_ActiveDirectory_Field_ClientID')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_ActiveDirectory_Field_ClientSecret')"
        :hint="$t('Integrations_ActiveDirectory_Text_ClientSecretValid')"
        prop="params.ad_client_secret"
      >
        <el-input
          v-model="model.params.ad_client_secret"
          :placeholder="$t('Integrations_ActiveDirectory_Field_ClientSecret')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_SyncSettings')">
      <rest-form-item
        prop="params.mirror_sync"
        :hint="$t('Integrations_ActiveDirectory_Text_MirrorSyncWarning')"
      >
        <el-switch
          v-model="model.params.mirror_sync"
          :active-text="$t('Integrations_ActiveDirectory_Field_MirrorSync')"
        />
      </rest-form-item>

      <rest-form-item
        prop="params.whitelist_users"
        :hint="
          $t('Integrations_ActiveDirectory_Field_WhitelistUsers_Description')
        "
      >
        <el-switch
          v-model="model.params.whitelist_users"
          :active-text="$t('Integrations_ActiveDirectory_Field_WhitelistUsers')"
        />
      </rest-form-item>

      <rest-form-item
        v-if="model.params.whitelist_users"
        prop="params.whitelisted_users"
        :hint="
          $t('Integrations_ActiveDirectory_Field_WhitelistedUsers_Description')
        "
      >
        <el-input
          type="textarea"
          v-model="model.params.whitelisted_users"
          :rows="6"
        ></el-input>
      </rest-form-item>

      <rest-form-item
        prop="params.whitelist_groups"
        :hint="
          $t('Integrations_ActiveDirectory_Field_WhitelistGroups_Description')
        "
      >
        <el-switch
          v-model="model.params.whitelist_groups"
          :active-text="
            $t('Integrations_ActiveDirectory_Field_WhitelistGroups')
          "
        />
      </rest-form-item>

      <rest-form-item
        v-if="model.params.whitelist_groups"
        prop="params.whitelisted_groups"
        :hint="
          $t('Integrations_ActiveDirectory_Field_WhitelistedGroups_Description')
        "
      >
        <el-input
          type="textarea"
          v-model="model.params.whitelisted_groups"
          :rows="6"
        ></el-input>
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'ActiveDirectorySettings',

  components: {
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          ad_tenant_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          ad_client_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          ad_client_secret: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/activedirectory/ActiveDirectorySettings.vue